<template>
  <div>
    <campus-attendance-teacher v-if="isTeacher" />
  </div>
</template>
<script>
import CampusAttendanceTeacher from './campus-attendance-teacher/index'
export default {
  name: 'attendance',
  components: {
    CampusAttendanceTeacher
  },
  computed: {
    isTeacher () {
      return this.$store.getters.isTeacherLogin
    }
  }
}
</script>
